import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { LambdaService } from 'src/app/lambda.service';
import { ThemingService } from 'src/app/theming.service';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-blocked-slots-table',
  templateUrl: './blocked-slots-table.component.html',
  styleUrls: ['./blocked-slots-table.component.scss']
})
export class BlockedSlotsTableComponent implements OnInit {
  blockedSlots: any[] = [];
  showStatusModal = false;
  statusModalType: 'loading' | 'success' = 'loading';
  statusModalMessage = '';

  constructor(
    private lambdaService: LambdaService,
    public themingService: ThemingService,
    private apiService: ApiService,
    private cdr: ChangeDetectorRef) { }

  async ngOnInit() {
    await this.loadBlockedSlots();
  }

  private extractCalendarBlocks(response: any): any[] {
    if (!response || typeof response !== 'object') return [];

    if (Array.isArray(response.calendarBlocks)) {
      return response.calendarBlocks;
    }

    if (response.body) {
      try {
        const parsed = JSON.parse(response.body);
        return parsed.calendarBlocks || [];
      } catch {
        return [];
      }
    }

    return [];
  }

  private async loadBlockedSlots(): Promise<void> {
    const shopId = this.themingService.shopId;
    if (!shopId) {
      this.blockedSlots = [];
      return;
    }

    try {
      const response = await this.lambdaService.getBlockHoursAndDays(shopId);
      this.blockedSlots = this.extractCalendarBlocks(response);
    } catch (error) {
      this.blockedSlots = [];
      console.error('Error fetching blocked slots:', error);
    }
  }

  async unblock(slot: any) {
    const shopId = this.themingService.shopId;
    const externalId = slot.externalId || slot.external_id || slot.id;
    const start_datetime = slot.start_datetime || slot.start;
    const end_datetime = slot.end_datetime || slot.end;
    const blockId = slot.blockId || slot.block_id || slot.id;

    this.statusModalType = 'loading';
    this.statusModalMessage = 'Desbloqueando horario';
    this.showStatusModal = true;

    try {
      const res = await this.apiService.unlockDates(shopId, externalId, start_datetime, end_datetime, blockId);
      this.handleResourceSuccess('Horario desbloqueado correctamente');
      this.ngOnInit();
    } catch (e) {
      this.closeStatusModalWithError('Ha ocurrido un error al eliminar el recurso: ' + (e as any).message);
      console.error('Error unlocking slot:', e);
    }
  }

  formatHorario(slot: any): string {
    const start = new Date(slot.start_datetime);
    const end = new Date(slot.end_datetime);

    const dias = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
    const meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
      'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

    const diaSemana = dias[start.getUTCDay()];
    const diaMes = start.getUTCDate();
    const mes = meses[start.getUTCMonth()];

    const startHour = start.getUTCHours();
    const startMinute = start.getUTCMinutes();
    const endHour = end.getUTCHours();
    const endMinute = end.getUTCMinutes();

    const isFullDay =
      startHour === 0 &&
      startMinute === 0 &&
      (endHour === 23 || endHour === 23) &&
      endMinute >= 59;

    if (isFullDay) {
      return `${diaSemana} ${diaMes} ${mes} · Todo el día`;
    }

    const formatHora = (d: Date) =>
      d.toLocaleTimeString('es-ES', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
        timeZone: 'UTC'
      });

    return `${diaSemana} ${diaMes} de ${formatHora(start)} a ${formatHora(end)}`;
  }

  private handleResourceSuccess(message: string) {
    this.statusModalType = 'success';
    this.statusModalMessage = message;
    setTimeout(() => {
      this.showStatusModal = false;
      this.cdr.detectChanges();
    }, 2000);
  }

  closeStatusModalWithError(msg: string) {
    this.statusModalType = 'success';
    this.statusModalMessage = msg;
    setTimeout(() => {
      this.showStatusModal = false;
      this.cdr.detectChanges();
    }, 2500);
  }

  onModalClosed(): void {
    this.showStatusModal = false;
  }
}
